import React, { Component } from 'react';

import { TableLayout } from '../Menu/Stock/containers/Layout';
import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';

import NewAgent from '../Menu/module/paygoNewAgentDynamic.jsx' 
import AgentStats from './Agents/AgentStats';
import { isEmpty } from "lodash";
import NewZone from '../Menu/module/paygoNewZone';
import AgentOptions from './Agents/AgentOptions';
import CommercialPopUp from './Agents/CommercialPopUp';
import { Grid, Button, TableHead, TableBody, TableRow, Box, TableCell, IconButton } from '@material-ui/core';
import { FormatListBulletedRounded, BarChartRounded, MoreVertRounded, AddCircleOutlineRounded, PinDropRounded } from '@material-ui/icons';
import PageAdmin from './Layouts/PageAdmin';
import SearchBarAction from './Layouts/SearchBarAction';
import CardButton from '../../commonModules/interface/CardButton';
import { removeUrlParams } from '../urlParams';

class AgentsList extends Component {
    state = { 
        new: false,
        suivi: false,
        openOptions: false,
        isRZ: false,
        list: [],
        details: false,
        current: "",
        openFormTypes: false,
        // Agent demandé par l'URL (?agentId=) mais absent de la liste chargée.
        agentNotFound: "",
     }
    // Identifiant demandé par l'URL, ouvert une seule fois quand la liste est chargée.
    urlAgentId = new URLSearchParams(window.location.search).get("agentId") || ""
    urlAgentHandled = false
    // Vrai une fois la 1re récupération de la liste terminée (liste vide comprise).
    agentsLoaded = false
    componentDidMount = async  () => {
        const { AGENTS, STATE } = this.props;
        if( isEmpty(AGENTS) ){
            await this.props.fetchAgents()
        }
        this.filterList()
        this.agentsLoaded = true
        if (!isEmpty(this.props.AGENTS)) {
            this.openAgentFromUrl()
        } else {
            // Props pas encore à jour juste après le dispatch : on tranche au tour suivant.
            setTimeout(this.openAgentFromUrl, 0)
        }
        if(!STATE.zones.fetching && !STATE.zones.fetched){
            this.props.getZoneList()
        }
        // if( isEmpty(this.props.COMMERCIAL_STOCKS) ){
        //     this.props.fetchCommercialStocks()
        // }
        // if( isEmpty(this.props.COMMERCIAL_REAS) ){
        //     await this.props.fetchCommercialReas()
        // }
        // if( isEmpty(this.props.COMMERCIAL_RETURNS) ){
        //     await this.props.fetchCommercialReturns()
        // }
        // if( isEmpty(this.props.SALES) ){
        //     await this.props.fetchSales()
        // }
    }
    // Ouvre la fiche (AgentOptions) de l'agent de l'URL, comme le clic sur « Options » de sa ligne.
    openAgentFromUrl = () => {
        const AGENTS = this.props.AGENTS || {}
        if (!this.urlAgentId || this.urlAgentHandled || (isEmpty(AGENTS) && !this.agentsLoaded)) {
            return
        }
        this.urlAgentHandled = true
        removeUrlParams(["agentId"])
        const agent = AGENTS[this.urlAgentId]
        if (agent) {
            this.setState({ agentNotFound: "", openOptions: true, current: this.urlAgentId, isRZ: agent.isRZ })
        } else {
            this.setState({ agentNotFound: this.urlAgentId })
        }
    }
    componentDidUpdate = (prevProps) => {
        // La liste peut arriver après le montage (fetchAgents) : on retente quand elle change.
        if (prevProps.AGENTS !== this.props.AGENTS) {
            this.openAgentFromUrl()
        }
    }
    // La zone declaree au bailleur est reservee aux administrateurs des agents / des integrations
    // (le backend l'ignore sinon) : les listes ne sont proposees qu'a ces utilisateurs.
    canEditLocation = () => {
        const { configList, pageList } = this.props;
        return (Array.isArray(pageList) && pageList.includes("Configuration"))
            || (Array.isArray(configList) && (configList.includes("agentadmin") || configList.includes("settings")))
    }
    openPopUp = async (agent) => {
        this.setState({
            agentNotFound: "",
            details:true,
            current:agent.id
        })
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.AGENTS) ){
                list = Object.keys(this.props.AGENTS)
            } else {
                list = []
            }
        }
        this.setState({
            list
        })
    }
    render() {
        const { AGENTS } = this.props;
        const { details, current, openOptions} = this.state;
        // console.log("RENDER ==> AGENT LIST")
        // console.log(this.state)

        let actions = [
            {
                openAction:() => this.setState({ new: true }),
                icon:<AddCircleOutlineRounded color="primary"/>,
                title: "Commercial"
            },
            {
                openAction: () =>this.setState({ newZone: true }),
                icon: <PinDropRounded color="secondary" />,
                title: "Zone"
            },
        ]
            // <Button 
            //     variant="contained"
            //     startIcon={<AddCircleOutlineRounded />}
            //     color="primary"
            //     onClick={()=>
            //         this.setState({ new: true })
            //     }>Commercial</Button>
            //     <br/>
            // <Button 
            //     variant="contained"
            //     startIcon={<AddCircleOutlineRounded />}
            //     color="secondary"
            //     onClick={()=>
            //         this.setState({ newZone: true })
            //     }>Zone</Button>
        return (
            <PageAdmin title="Agents Commerciaux">
                {this.state.new &&
                    <NewAgent 
                        {...this.props}
                        canEditLocation={this.canEditLocation()}
                        popupState={"overlay"} 
                        onCloseOverlay={ ()=> this.setState({ new: false }) }
                        onUpdate={() => {
                            console.log("Update Agent List");
                            this.props.fetchAgents()}
                        }
                    />
                    }
                {this.state.newZone &&
                    <NewZone 
                        {...this.props}
                        onClose={() => this.setState({ newZone: false }) }
                        onUpdate={() => {
                            console.log("Update ZONE");
                            this.props.getZoneList()
                        }}
                    />
                }
                {( details && current ) &&
                    <CommercialPopUp
                        closePopUp={() => this.setState({
                            details: false,
                            current: ""
                        })} 
                        commercial={AGENTS[current]}
                        STOCK_INFO_LIST
                        updateAgent={this.props.updateAgent}
                        // fetchProducts={this.props.fetchProducts}
                        // fetchCommercialStocks={this.props.fetchCommercialStocks}
                        // fetchCommercialReturns={this.props.fetchCommercialReturns}
                        // fetchCommercialReas={this.props.fetchCommercialReas}
                        {...this.props}
                    />
                    
                }
                {this.state.openFormTypes &&
                    <Dialog
                        title="Nouveau"
                        block={true}
                        close={() => this.setState({ 
                            openFormTypes: false,
                        }) }
                    >
                        {actions.map(action =>
                            <CardButton
                                action={action.openAction}
                                icon={action.icon}
                                title={action.title}
                            />
                        )}
                    </Dialog>
                }

                {( openOptions && current ) &&
                    // <Dialog 
                    //     title="Options"
                    //     block={openOptions}
                    //     close={()=> this.setState({openOptions:false, current:""}) }
                    // >
                        <AgentOptions 
                            canEditLocation={this.canEditLocation()}
                            isRZ={this.state.isRZ} 
                            listAgent={AGENTS} 
                            userID={this.state.current} 
                            close={()=> { 
                                this.props.fetchAgents();
                                this.setState({openOptions:false, current:""})}
                            }
                        /> 
                    // </Dialog>
                }
                {/* <h3>Agents Commerciaux</h3> */}
               
                {this.state.agentNotFound &&
                    <Box p={1}>
                        <b style={{color: 'red'}}>{"Agent " + this.state.agentNotFound + " introuvable dans ce compte"}</b>
                    </Box>
                }
                <SearchBarAction list={ AGENTS } filterList={this.filterList} action={() => this.setState({ openFormTypes : true}) }/>
                {this.state.suivi ? (
                    <div>
                        <div className="text-right">
                            <Button 
                                variant="contained" 
                                title="Liste des Commerciaux"
                                onClick={()=>
                                    this.setState({ suivi: false })
                                }>
                                {/* <i className="zmdi zmdi-format-list-bulleted"></i> */}
                                <FormatListBulletedRounded />
                            </Button>                        
                        </div>
                        <AgentStats {...this.state} {...this.props}/>
                    </div>
                ) : (
                    <div>
                        {/* <div className="text-right">
                            <Button 
                                variant="contained" 
                                title="Suivi Performance"
                                onClick={()=>
                                    this.setState({ suivi: true })
                                }>
                                <BarChartRounded />
                            </Button>                        
                        </div> */}
                        <TableLayout>
                        {/* height={"690px"} */}
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">ID</TableCell>
                                    <TableCell component="th">Name</TableCell>
                                    <TableCell component="th">Phone</TableCell>
                                    <TableCell component="th">Email</TableCell>
                                    <TableCell component="th">Zone</TableCell>
                                    <TableCell component="th">Entreprise</TableCell>
                                    <TableCell component="th">Options</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {AGENTS && this.state.list.map( ID => {
                                    let agent = AGENTS[ID]
                                    let colorLine = {}
                                    if (agent.isRZ) {
                                        colorLine = {color:"red"}
                                    }
                                    return(
                                        <TableRow key={agent.id} style={colorLine}>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.externalid}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.name}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{
                                                (Array.isArray(agent.phone) ? 
                                                agent.phone[0] : 
                                                agent.phone) 
                                                // (Array.isArray(agent.phone) ? 
                                                // agent.phone.join("\r\n") : 
                                                // agent.phone) 
                                                }</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.email}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.zone}</TableCell>
                                            <TableCell onClick={()=> this.openPopUp(agent)} >{agent.company}</TableCell>
                                            <TableCell>
                                                <IconButton 
                                                    onClick={()=> this.setState({agentNotFound: "", openOptions: true, current: ID,isRZ:agent.isRZ}) }
                                                >
                                                    {/* <i className="zmdi zmdi-more-vert"></i> */}
                                                    <MoreVertRounded />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                } )
                            }
                            </TableBody>
                        </TableLayout>
                    </div>
                )}
                        
            </PageAdmin>
        );
    }
}

export default AgentsList